import type { RouteRecordNameGeneric } from 'vue-router'

// Extract the name without the i18n suffix (e.g. ___de)
export const normalizeRouteName = (routeName: RouteRecordNameGeneric) => {
  return typeof routeName === 'string' ? routeName.split('___')[0] : undefined
}

export function formatWithLeadingZeros(value: number, leadingZeros: number): string {
  if (!value) {
    return ''
  }
  return value.toString().padStart(leadingZeros, '0')
}

export function formatWishlistId(wishlistId: number): string {
  return formatWithLeadingZeros(wishlistId, 7)
}
